export default function FloatingBottomBar() {
  return null;
}
